import { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../api/index.js";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("fogra_user");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fogra_token");
    if (!token) { setLoading(false); return; }
    authAPI.me()
      .then(res => {
        setUser(res.data.user);
        localStorage.setItem("fogra_user", JSON.stringify(res.data.user));
      })
      .catch(() => {
        localStorage.removeItem("fogra_token");
        localStorage.removeItem("fogra_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem("fogra_token", res.data.token);
    localStorage.setItem("fogra_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (username, email, password) => {
    const res = await authAPI.register({ username, email, password });
    localStorage.setItem("fogra_token", res.data.token);
    localStorage.setItem("fogra_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("fogra_token");
    localStorage.removeItem("fogra_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
